import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ErrorHandling from './ErrorHandling';
import './ErrorHandlingModal.css';

const ErrorHandlingModal = ({ open, onClose, projectId, projectName }) => {
  const handleOpenInNewTab = () => {
    window.open(`/project/error_handling/${projectId}`, '_blank');
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="error-handling-modal"
      aria-describedby="error-handling-in-modal"
    >
      <Box className="error-handling-modal-box">
        <AppBar position="static" elevation={0} className="error-handling-modal-appbar">
          <Toolbar className="error-handling-modal-toolbar">
            <div style={{ flexGrow: 1 }} />
            <IconButton color="inherit" onClick={handleOpenInNewTab} aria-label="open in new tab">
              <OpenInNewIcon />
            </IconButton>
            <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div className="error-handling-modal-content">
          <ErrorHandling
            params={{ id: projectId }}
            location={{ state: { project_name: projectName } }}
            navigate={() => {}}
            isModal={true}
            onClose={onClose}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default ErrorHandlingModal;
